import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'

defineRule('required_without_any', (value, otherValues) => {
  if (value || otherValues.filter(Boolean).length > 0) {
    return true
  }
  return i18n.global.t('form.at_least_one_field_is_required')
})
